<table class="table">
  <thead>
    <tr>
      <th>Dataset</th>
      <th></th>
    </tr>
  </thead>

  <tbody>
    <ng-container *ngFor="let dataset of datasets">
      <tr>
        <td>{{ dataset }}</td>
        <td>
          <div
            class="btn btn-danger btn-sm fa fa-trash"
            [ngClass]="{ disabled: requestInProgress }"
            (click)="!requestInProgress && deleteDataset(dataset)"></div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
